import React, { useEffect, useRef, useState } from 'react'
import {
  CCol, CRow, CAlert, CForm, CFormInput, CFormLabel, CButton, CSpinner,
  CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter,
} from '@coreui/react'
import { api } from '../api/client'
import WwGrid, { WwColumn } from '../components/ww/WwGrid'
import { usePendiente } from '../components/ww/pendiente'

const columnas: WwColumn[] = [
  { key: 'rolCodigo', title: 'Codigo', type: 'number' },
  { key: 'rolNombre', title: 'Nombre' },
  { key: 'rolPuntoCaida', title: 'Punto Caida' },
]

// Roles — réplica de rolgeneral.cs:53 (rolgeneral GX).
const RolesPage: React.FC = () => {
  const [rows, setRows] = useState<any[]>([])
  const formRef = useRef<HTMLFormElement>(null)
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState('')
  const { aviso, setAviso } = usePendiente()
  const [abierto, setAbierto] = useState(false)
  const [guardando, setGuardando] = useState(false)
  const [errorModal, setErrorModal] = useState('')
  const [form, setForm] = useState({ rolCodigo: '', rolNombre: '', rolPuntoCaida: '' })
  // Fila en edición (rolww.cs:2061 'DO UPDATE' → webobject rol Mode="UPD")
  const [editando, setEditando] = useState<any | null>(null)

  useEffect(() => {
    api.get<any[]>('/roles')
      .then(setRows)
      .catch((e: any) => setError(e.message))
      .finally(() => setCargando(false))
  }, [])

  const abrirNuevo = () => {
    setEditando(null)
    setForm({ rolCodigo: '', rolNombre: '', rolPuntoCaida: '' })
    setAbierto(true)
  }

  // Modificar (rolww.cs:2061-2067): carga la fila. RolCodigo es llave y no cambia.
  const abrirEditar = (fila: any) => {
    setErrorModal('')
    setEditando(fila)
    setForm({
      rolCodigo: String(fila.rolCodigo ?? ''),
      rolNombre: fila.rolNombre ?? '',
      rolPuntoCaida: fila.rolPuntoCaida ?? '',
    })
    setAbierto(true)
  }

  const crear = async (e: React.FormEvent) => {
    e.preventDefault()
    setErrorModal('')
    setGuardando(true)
    try {
      if (editando) {
        // UPD: la llave va en la URL (rol_bc.cs:344-364, BC000M7)
        await api.put(`/roles/${editando.rolCodigo}`, {
          rolNombre: form.rolNombre,
          rolPuntoCaida: Number(form.rolPuntoCaida),
        })
      } else {
        await api.post('/roles', {
          rolCodigo: Number(form.rolCodigo),
          rolNombre: form.rolNombre,
          rolPuntoCaida: Number(form.rolPuntoCaida),
        })
      }
      setAbierto(false)
      setEditando(null)
      api.get<any[]>('/roles').then(setRows)
    } catch (err: any) {
      setErrorModal(err.message)
    } finally {
      setGuardando(false)
    }
  }

  // Eliminar (rolww.cs:2069-2077 'DO DELETE'): el backend replica
  // OnDeleteControls0M4 (rol_bc.cs:447-451, BC000M9) → 409 si hay Usuarios.
  const eliminar = (fila: any) => {
    if (!window.confirm(`¿Eliminar el rol ${fila.rolCodigo}?`)) return
    api.delete(`/roles/${fila.rolCodigo}`)
      .then(() => {
        setAviso('Rol eliminado.')
        api.get<any[]>('/roles').then(setRows)
      })
      .catch((e: any) => setError(e.message))
  }

  const [totalReg, setTotalReg] = useState(rows.length)
  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4>Rol</h4>
          <small className="text-body-secondary">{totalReg} {totalReg === 1 ? 'registro' : 'registros'}</small>
        </CCol>
      </CRow>
      {error && <CAlert color="danger">{error}</CAlert>}
      {aviso && <CAlert color="warning" dismissible onClose={() => setAviso('')}>{aviso}</CAlert>}

      <WwGrid
        title="Rol"
        columns={columnas}
        rows={rows}
        onTotalChange={setTotalReg}
        loading={cargando}
        onAgregar={abrirNuevo}
        onEditar={abrirEditar}
        onEliminar={eliminar}
      />

      <CModal visible={abierto} onClose={() => { setAbierto(false); setEditando(null) }}>
        <CModalHeader>
          <CModalTitle>{editando ? 'Modificar rol' : 'Agregar rol'}</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ maxHeight: '75vh', overflowY: 'auto' }}>
          {errorModal && <CAlert color="danger">{errorModal}</CAlert>}
          <CForm ref={formRef} onSubmit={crear}>
            <CRow className="g-3">
              <div className="w-100"><small className="text-body-secondary fw-semibold">Rol</small></div>
              <CCol md={4}><CFormLabel>Código</CFormLabel><CFormInput type="number" value={form.rolCodigo} disabled={editando !== null} onChange={(e) => setForm({ ...form, rolCodigo: e.target.value })} /></CCol>
              {/* Mayúsculas (patrón GX: nombres en BD en mayúsculas) */}
              <CCol md={4}><CFormLabel>Nombre</CFormLabel><CFormInput value={form.rolNombre} onChange={(e) => setForm({ ...form, rolNombre: e.target.value.toUpperCase() })} /></CCol>
              <CCol md={4}><CFormLabel>Punto Caida</CFormLabel><CFormInput type="number" value={form.rolPuntoCaida} onChange={(e) => setForm({ ...form, rolPuntoCaida: e.target.value })} /></CCol>
            </CRow>
          </CForm>
        </CModalBody>
        <CModalFooter className="border-top">
          <CButton color="secondary" type="button" disabled={guardando} onClick={() => setAbierto(false)}>Cancelar</CButton>
          <CButton color="primary" type="button" disabled={guardando} onClick={() => formRef.current?.requestSubmit()}>{guardando ? <CSpinner size="sm" /> : 'Guardar'}</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default RolesPage
